/**
 * region for libraries*/
import React, { Component } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { withStyles } from "@material-ui/core/styles";
import { AppBar, Drawer } from "@material-ui/core";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

/**
 * region for styles*/
import { layoutCrawlersStyle } from "./style/layoutCrawlersStyle";

/**
 * region for containers*/
import HeaderCrawlers from "../../../containers/crawlers/HeaderCrawlers";

import ReportRss from "../../../containers/crawlers/ReportRss";

/**
 * region for hepers*/

/**
 * region for constans*/

class LayoutCrawlers extends Component {
  state = {
    showMenu: false, //permanet disabled
  };

  

  render() {
    const { classes } = this.props;
    const { showMenu } = this.state;
    return (
      <Router>
        <div className={classes.root}>
          <AppBar className={clsx(classes.appBar)} position="absolute" color="inherit" elevation={0}>
            <HeaderCrawlers />
          </AppBar>
          {showMenu && <Drawer classes={{ paper: clsx(classes.drawerPaper) }} open={true} variant="permanent"></Drawer>}
          <div className={classes.content}>
            <div className={classes.appBarSpacer} />
            <Switch>
              <Route exact path="/LayoutCrawlers">
                <ReportRss />
              </Route>
            </Switch>
          </div>
        </div>
      </Router>
    );
  }
}
LayoutCrawlers.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(layoutCrawlersStyle)(LayoutCrawlers);
